module.exports = "<div [style.width]=\"width\" [style.height]=\"height\" class=\"map-container\">\n\n  <div #mapPlaceholder class=\"full-width full-height map\"></div>\n\n  <div class=\"map-overlay\">\n    <div class=\"controls-container\">\n      \n      <ng-content></ng-content>\n\n    </div>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/core/maps/map.component.html
// module id = ../../../../../src/app/core/maps/map.component.html
// module chunks = 0